export const loadSvgImage = (container: HTMLDivElement, base64: string) => {
    const dataURL = "data:image/svg+xml;base64," + base64;
    const xhr = new XMLHttpRequest();
    xhr.open("GET", dataURL);
    xhr.addEventListener("load", function (ev: any) {
      const xml = ev.target.response;
      const dom = new DOMParser();
      const svg = dom.parseFromString(xml, "image/svg+xml");
      // svg.documentElement?.setAttribute("height", "200px");
      // svg.documentElement?.setAttribute("width", "200px");
      svg.documentElement?.setAttribute("height", "220px");
      svg.documentElement?.setAttribute("width", "220px");
      if (container.children.length === 0) {
        container.appendChild(svg.documentElement);
      }
    });
    xhr.send(null);
  };
  